import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "pu-home" */ './views/home.vue'),
        meta: {
            title: 'Home',
            auth: {
                roles: ['PU_00001'],
                redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado'
            },
        }
    },
];

export default routes;